import React, { Fragment } from 'react';
import Button from '@mui/material/Button';

import CommonDialog from './common/commonDialog';

const UnsavedChangesDialog = ({
    isOpen,
    handleClose,
    handleContinue
}: {
    isOpen: boolean;
    handleClose: () => void;
    handleContinue: () => void;
}): JSX.Element => {

    return (
        <CommonDialog
            open={isOpen}
            onClose={handleClose}
            content='The form has unsaved changes. If you continue your changes will be lost.'
            actions={(
                <Fragment>
                    <Button
                        onClick={handleClose}
                        data-qa='cancel-button'
                    >
                        Cancel
                    </Button>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={handleContinue}
                        data-qa='continue-button'
                    >
                        Continue
                    </Button>
                </Fragment>
            )}

        />
    );
};

export default UnsavedChangesDialog;
